import React, { useState, useEffect } from "react";
import axios from "../utils/axios";
import Select from "react-select";
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import { getUser, setUserHID, getToken } from "../utils/Common";
import { useNavigate } from 'react-router-dom';
import OneSignal from 'react-onesignal';

const Dashboard = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [isMiniSidebar, setMiniSidebar] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [listProp, setListProp] = useState([]);

  const chooseProperty = async (hotel, url) => {
    navigate(`/property/${hotel}/${url}`);
    setUserHID(hotel);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const userSession = getUser();
      
      if (userSession) {
        setUserData(userSession);
        
        try {
          const hotel = userSession.hotel_id;
          const token = getToken();
          
          if (!hotel) {
            throw new Error('Hotel ID is missing');
          }
           
          const response = await axios.post('/api/hotels', {hotel}, {
            headers: { 
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          });

          if (response.status === 200) {
            const flattenedData = response.data.data.flat();
            setListProp(flattenedData);
          } else {
            throw new Error('Failed to fetch property list');
          }
        } catch (err) {
          console.error('Error fetching data:', err);
        } finally {
          setLoading(false);
        }
      } else {
        navigate('/');
      }
    };
    
    fetchData();
  }, []);

  return (
    <div className="flex h-screen bg-gray-200">
      {/* Sidebar */}
      {/* <Sidebar setMiniSidebar={setMiniSidebar} isMiniSidebar={isMiniSidebar}/> */}

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Topbar */}
        <Topbar setMiniSidebar={setMiniSidebar} isMiniSidebar={isMiniSidebar} />

        {/* Main Section */}
        <main className="flex-1 p-5 overflow-y-auto bg-gray-100">
          
          {isLoading ? (
            /* Loading Indicator */
            <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
              <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#0f1827] mb-4"></div>
                <p className="text-gray-700">Load Data...</p>
              </div>
            </div>
          ) : (
            <>
            {/* Content Section & Breadcrumb */}
            <div className="mb-4 text-xs text-[#101827]">
              <span>Ashley Hotel Group</span> &gt; <span>Dashboard</span> &gt; <span> Booking Engine</span> &gt; <span>  Hotel List</span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {listProp.map((data, index) => (
                <div key={index} className="w-full bg-[#080F23] rounded-2xl shadow-lg p-4">
                  <div className="flex justify-center">
                    <img
                      src={data.LOGO_HOTEL || "https://via.placeholder.com/80"}
                      alt={data.NAME_HOTEL || "Hotel Logo"}
                      className="w-20 h-20 rounded-full border-2 bg-white border-gray-200 p-1 shadow-lg object-scale-down"
                    />
                  </div>
                  <div className="text-center mt-4">
                    <h3 className="text-base font-semibold text-gray-100">{data.NAME_HOTEL || "Hotel Name"}</h3>
                    <p className="text-xs text-gray-500">{data.ADDRESS1 || "No Address Provided"}</p>
                  </div>
                  <div className="mt-6 text-center">
                    <button
                      className="bg-slate-300 text-slate-800 text-sm font-medium py-2 px-4 rounded-full hover:bg-slate-200 transition duration-300"
                      onClick={() => chooseProperty(data.ID_HOTEL, data.URL)}
                    >
                      View Details
                    </button>
                  </div>
                </div>
              ))}
            </div>
            </>
          )}
        </main>
      </div>
    </div>
  );
};

export default Dashboard;